import type { JSXNode } from "./types";

/**
 * Get a key for a JSX element or index
 */
export const getKey = (element: JSXNode, index: number): string | number => {
  if (element && typeof element === "object" && element.key != null) {
    return element.key;
  }
  return index;
};

/**
 * Check if two ranges are the same
 */
export const isSameRange = (
  prev: [number, number],
  next: [number, number]
): boolean => {
  return prev[0] === next[0] && prev[1] === next[1];
};

/**
 * Create a ref key for accessing current values
 */
export const refKey = "current" as const;
